// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"forgot-password_wrapper__2AMTz","link":"forgot-password_link__1xRFL","errorMessage":"forgot-password_errorMessage__1QXnu"};